module.exports = __webpack_public_path__ + "img/logo_amore@3x.5522f540.png";